import { useState } from "react";
import { categories } from "@/mocks/categories";

const categoryImages: string[] = [
  "https://readdy.ai/api/search-image?query=Pair%20of%20modern%20white%20and%20beige%20sneakers%20arranged%20on%20warm%20cream%20linen%20surface%20soft%20natural%20daylight%20minimal%20editorial%20product%20photography%20clean%20composition%20neutral%20warm%20tones&width=800&height=600&seq=catgrid-shoes-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Cozy%20oversized%20cream%20knit%20sweater%20draped%20elegantly%20over%20warm%20beige%20linen%20fabric%20soft%20diffused%20natural%20light%20minimal%20editorial%20product%20photography%20inviting%20textures%20visible%20stitch%20pattern&width=800&height=600&seq=catgrid-hoodies-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Premium%20white%20cotton%20t-shirt%20neatly%20folded%20on%20cream%20surface%20with%20dried%20eucalyptus%20branch%20alongside%20soft%20natural%20daylight%20casting%20gentle%20shadows%20minimal%20editorial%20product%20photography&width=800&height=600&seq=catgrid-tshirts-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Sleek%20olive%20green%20field%20jacket%20hanging%20on%20minimal%20wooden%20hanger%20against%20cream%20textured%20wall%20natural%20sunlight%20creating%20soft%20highlights%20minimal%20editorial%20product%20photography%20warm%20earth%20tones&width=800&height=600&seq=catgrid-jackets-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Single%20pair%20of%20beige%20linen%20cargo%20pants%20neatly%20folded%20on%20warm%20cream%20surface%20soft%20natural%20daylight%20minimal%20editorial%20product%20photography%20clean%20composition%20neutral%20warm%20tones&width=800&height=600&seq=catgrid-pants-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Single%20black%20baseball%20cap%20and%20beige%20beanie%20arranged%20on%20cream%20surface%20soft%20natural%20light%20minimal%20editorial%20product%20photography%20warm%20neutral%20tones%20clean%20composition&width=800&height=600&seq=catgrid-headwear-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Matching%20beige%20coordinated%20outfit%20set%20with%20top%20and%20bottom%20pieces%20folded%20together%20on%20warm%20cream%20surface%20soft%20daylight%20minimal%20editorial%20product%20photography%20clean%20aesthetic&width=800&height=600&seq=catgrid-sets-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20briefs%20neatly%20folded%20on%20cream%20textured%20fabric%20soft%20natural%20light%20minimal%20editorial%20product%20photography%20warm%20lighting%20clean%20aesthetic&width=800&height=600&seq=catgrid-underwear-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Vibrant%20red%20sports%20jersey%20neatly%20folded%20on%20warm%20cream%20surface%20soft%20natural%20daylight%20minimal%20editorial%20product%20photography%20clean%20composition%20neutral%20warm%20tones&width=800&height=600&seq=catgrid-jersey-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Elegant%20gold%20watch%20and%20stylish%20sunglasses%20arranged%20on%20cream%20surface%20soft%20natural%20light%20minimal%20editorial%20product%20photography%20warm%20neutral%20tones%20clean%20composition&width=800&height=600&seq=catgrid-accessories-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Tan%20leather%20crossbody%20bag%20with%20minimal%20gold%20hardware%20on%20warm%20cream%20surface%20soft%20natural%20daylight%20minimal%20editorial%20product%20photography%20clean%20composition%20neutral%20warm%20tones&width=800&height=600&seq=catgrid-bags-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Single%20brown%20leather%20belt%20with%20minimal%20brass%20buckle%20coiled%20on%20cream%20surface%20soft%20natural%20light%20minimal%20editorial%20product%20photography%20warm%20neutral%20tones&width=800&height=600&seq=catgrid-belts-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20with%20minimal%20gold%20cap%20on%20warm%20cream%20surface%20soft%20natural%20daylight%20minimal%20editorial%20product%20photography%20clean%20aesthetic&width=800&height=600&seq=catgrid-perfumes-v6&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Assorted%20small%20lifestyle%20gadgets%20and%20accessories%20neatly%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20light%20minimal%20editorial%20product%20photography%20clean%20composition&width=800&height=600&seq=catgrid-other-v6&orientation=landscape",
];

function CategoryCard({ cat, idx }: { cat: typeof categories[0]; idx: number }) {
  const isHero = idx === 0;

  return (
    <a
      href={cat.url}
      target="_blank"
      rel="noopener nofollow"
      className={`group relative rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] ${
        isHero ? "sm:col-span-2 sm:row-span-2" : ""
      }`}
    >
      {/* Product image background */}
      <img
        src={categoryImages[idx]}
        alt={`${cat.name} products — Itaobuy Spreadsheet`}
        title={`Browse ${cat.name} — Itaobuy Spreadsheet`}
        className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
      />

      {/* Bottom gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/25 to-transparent" />

      {/* Content */}
      <div className={`relative z-10 p-5 md:p-6 flex flex-col ${
        isHero ? "h-full min-h-[280px] justify-between" : "h-full min-h-[180px] justify-between"
      }`}>
        {isHero ? (
          <>
            <div className="flex items-start justify-between">
              <span className="w-10 h-10 rounded-full flex items-center justify-center bg-white/20 text-white backdrop-blur-sm">
                <i className={`${cat.icon} text-lg`} />
              </span>
              <span className="px-2.5 py-1 rounded-full bg-white/15 text-white/80 text-xs backdrop-blur-sm">
                Featured
              </span>
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-semibold text-white mb-1">
                {cat.name}
              </h3>
              <p className="text-sm text-white/80">{cat.description}</p>
              <p className="text-xs text-white/50 mt-2">{cat.items} items</p>
            </div>
          </>
        ) : (
          <>
            <div className="flex items-start justify-between">
              <span className="w-8 h-8 rounded-full flex items-center justify-center bg-white/20 text-white backdrop-blur-sm">
                <i className={`${cat.icon} text-sm`} />
              </span>
              <span className="px-2 py-0.5 rounded-full bg-white/15 text-white/70 text-xs font-medium backdrop-blur-sm">
                {cat.items}
              </span>
            </div>
            <div>
              <h3 className="text-lg font-heading font-semibold text-white mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-white/60">{cat.items} items in stock</p>
            </div>
          </>
        )}
      </div>
    </a>
  );
}

export default function CategoryGrid() {
  const [showAll, setShowAll] = useState(false);
  const visibleCategories = showAll ? categories : categories.slice(0, 8);
  const hasMore = categories.length > 8;

  return (
    <section id="categories" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs text-foreground-500 uppercase tracking-widest mb-2">ITAOBUY / SHEET</p>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">Shop by Category</h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            Browse all {categories.length} product categories in the itaobuy spreadsheet. Click any category to explore curated products on the main platform.
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-product-shop="">
          {visibleCategories.map((cat, idx) => (
            <CategoryCard key={cat.slug} cat={cat} idx={idx} />
          ))}
        </div>

        {/* Show more / less */}
        {hasMore && (
          <div className="flex justify-center mt-8">
            <button
              onClick={() => setShowAll(!showAll)}
              className="px-6 py-2.5 rounded-full border border-background-300/70 bg-background-50 text-sm text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {showAll ? (
                <>Show Less <i className="ri-arrow-up-s-line ml-2" /></>
              ) : (
                <>View All {categories.length} Categories <i className="ri-arrow-down-s-line ml-2" /></>
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}